export default function DeleteIconButton({action, param}){
    return (
        <i class="bi bi-trash" style={{ marginLeft: "15px" }} onClick={() => action(param)}></i>
    )
}